// src/services/CarritoService.ts
import { config } from "@/config";
export const CarritoService = {
    // Obtener el carrito del usuario autenticado
    async getCarritoUser() {
        try {
            const response = await fetch(`${config.API_URL}/api/Carrito`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                    "Content-Type": "application/json",
                },
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.errores || "Error al obtener el carrito");
            }
            const data = await response.json();
            return data.datos;
        }
        catch (error) {
            throw new Error(error.message || "Error al obtener el carrito");
        }
    },
    // Obtener un carrito por ID
    async getCarrito(id) {
        try {
            const response = await fetch(`${config.API_URL}/api/Carrito/${id}`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                    "Content-Type": "application/json",
                },
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.errores || "Error al obtener el carrito");
            }
            // Puedes procesar los datos aquí si es necesario
        }
        catch (error) {
            throw new Error(error.message || "Error al obtener el carrito");
        }
    },
    // Crear un nuevo carrito
    async createCarrito() {
        try {
            const response = await fetch(`${config.API_URL}/api/Carrito`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                    "Content-Type": "application/json",
                },
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.errores || "Error al crear el carrito");
            }
        }
        catch (error) {
            throw new Error(error.message || "Error al crear el carrito");
        }
    },
    async vaciarCarrito() {
        try {
            const response = await fetch(`${config.API_URL}/api/Carrito/vaciarCarrito`, {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                    "Content-Type": "application/json",
                },
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.errores || "Error al vaciar el carrito");
            }
        }
        catch (error) {
            throw new Error(error.message || "Error al vaciar el carrito");
        }
    },
    // Actualizar un carrito
    async updateCarrito(carrito) {
        try {
            const response = await fetch(`${config.API_URL}/api/Carrito/${carrito.carritoID}`, {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(carrito),
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.errores || "Error al actualizar el carrito");
            }
        }
        catch (error) {
            throw new Error(error.message || "Error al actualizar el carrito");
        }
    },
    // Eliminar un carrito
    async deleteCarrito(id) {
        try {
            const response = await fetch(`${config.API_URL}/api/Carrito/${id}`, {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                },
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.errores || "Error al eliminar el carrito");
            }
        }
        catch (error) {
            throw new Error(error.message || "Error al eliminar el carrito");
        }
    },
    // Obtener detalles del carrito por ID
    async getDetalles(carritoId) {
        try {
            const response = await fetch(`${config.API_URL}/api/Carrito/${carritoId}/detalles`, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                    "Content-Type": "application/json",
                },
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.errores || "Error al obtener los detalles del carrito");
            }
            // Puedes procesar los detalles aquí si es necesario
        }
        catch (error) {
            throw new Error(error.message || "Error al obtener los detalles del carrito");
        }
    },
    async addDetalle(detalleCarrito) {
        try {
            const response = await fetch(`${config.API_URL}/api/Carrito/addDetalle`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(detalleCarrito),
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.errores || "Error al agregar el detalle al carrito");
            }
            return await response.json();
        }
        catch (error) {
            throw new Error(error.message || "Error al agregar el detalle al carrito");
        }
    },
    // src/services/CarritoService.ts
    async updateDetalle(id, cantidad) {
        try {
            const response = await fetch(`${config.API_URL}/api/Carrito/detalles/${id}`, {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(cantidad),
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.errores || "Error al actualizar el detalle del carrito");
            }
            return true; // Indica que la actualización fue exitosa
        }
        catch (error) {
            console.error("Error al actualizar el detalle:", error);
            return false; // Indica que la actualización falló
        }
    },
    // Eliminar un detalle del carrito
    async deleteDetalle(id) {
        try {
            const response = await fetch(`${config.API_URL}/api/Carrito/detalles/${id}`, {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                },
            });
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.errores || "Error al eliminar el detalle del carrito");
            }
        }
        catch (error) {
            throw new Error(error.message || "Error al eliminar el detalle del carrito");
        }
    },
};
